import  { IGetAllSendFriendRequest } from "../../models/Form/IGetSentFriendRequest";


export const initialSendFriendRequestState: IGetAllSendFriendRequest = {
    FriendRequestList:[]
};